import {ReactNode, useState, useCallback} from 'react'
import {MenuProvider, useMenuStore} from '@ariakit/react'
import {CSSProperties} from 'styled-components'

interface ContextMenuProps {
    children: ReactNode
    onContextMenu?: (e: React.MouseEvent<HTMLDivElement>, anchorRect: {x: number; y: number}) => void
    menu: (props: {anchorRect: {x: number; y: number}}) => ReactNode
    style?: CSSProperties
}

export const ContextMenu = ({children, onContextMenu, menu, style}: ContextMenuProps) => {
    const contextMenu = useMenuStore()
    const [anchorRect, setAnchorRect] = useState({x: 0, y: 0})

    const handleContextMenu = useCallback(
        (e: React.MouseEvent<HTMLDivElement>) => {
            e.preventDefault()
            const rect = {x: e.clientX, y: e.clientY}
            setAnchorRect(rect)
            onContextMenu?.(e, rect)
            contextMenu.show()
        },
        [contextMenu, onContextMenu]
    )

    return (
        <MenuProvider store={contextMenu}>
            <div onContextMenu={handleContextMenu} style={style}>
                {children}
                {menu({anchorRect})}
            </div>
        </MenuProvider>
    )
}
